var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCases = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 9.25,
    x: 2.5,
    y: 5.5,
    strokeWidth: 1.5,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M7 3.5c0-.552.448-1 1-1h2c.552 0 1 .448 1 1V5H7V3.5zM12.25 5.25L12.25 14.25M6.25 5.25L6.25 14.25"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCases, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cases.b2c2fad1.svg";
export { ForwardRef as ReactComponent };